// Shared by the browser catalogue and the quote API. Keep source datasets
// separate so each manufacturer's table can be reconciled independently.
const datasets = [
  require('./transitCustom.json'),
  require('./transit.json'),
  require('./transitConversions.json'),
  require('./transitConnect.json'),
  require('./transitCourier.json'),
];
const definitions = [
  ['transit-custom', 'Transit Custom'], ['transit', 'Transit'],
  ['tipper', 'Transit Tipper'], ['dropside', 'Transit Dropside'],
  ['transit-connect', 'Transit Connect'], ['transit-courier', 'Transit Courier'],
];
const vehicles = datasets.flatMap(dataset => dataset.vehicles.map(vehicle => ({
  ...vehicle,
  familyLabel: vehicle.familyLabel || definitions.find(([id]) => id === vehicle.family)?.[1],
  source: vehicle.source || dataset.source,
  checkedAt: dataset.checkedAt,
})));
const families = definitions.map(([id, label]) => ({ id, label, source: vehicles.find(vehicle => vehicle.family === id).source }));
module.exports = {
  version: 'ford-range-2026-10-15.1',
  checkedAt: '2026-10-15',
  vehicles, families,
  sources: Object.fromEntries(families.map(family => [family.id, family.source])),
};
